import httpClient from './httpClient';

const retrieveToken = (username, password) => httpClient.post('/api/login', { username, password });

const destroyToken = (username, password) => httpClient.post('/api/logout');

const magasins = () => httpClient.post('/api/users');

export {
    retrieveToken,
    destroyToken,
    magasins
}
